const footerLinks = [
  {
    title: '快速导航',
    links: [
      { label: '热门话题', href: '#topics' },
      { label: '平台特色', href: '#features' },
      { label: '最新动态', href: '#updates' },
      { label: '常见问题', href: '#faq' },
    ],
  },
  {
    title: '漫画分类',
    links: [
      { label: '热血战斗', href: '#topics' },
      { label: '甜宠恋爱', href: '#topics' },
      { label: '悬疑推理', href: '#topics' },
      { label: '异世界转生', href: '#topics' },
    ],
  },
  {
    title: '关于我们',
    links: [
      { label: '关于哔咔', href: '#about' },
      { label: '联系投稿', href: '#contact' },
      { label: '热门排行', href: '#ranking' },
      { label: '漫画索引', href: '#index' },
    ],
  },
];

export default function Footer() {
  return (
    <footer id="footer" className="bg-background-900 text-background-200 pt-14 pb-8 px-4 md:px-6">
      <div className="max-w-[1280px] mx-auto">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 mb-10">
          <div>
            <a
              href="#hero"
              className="font-heading text-xl text-background-50 mb-3 inline-block whitespace-nowrap cursor-pointer"
            >
              哔咔动漫
            </a>
            <p className="text-sm text-background-400 leading-relaxed">
              免费漫画全集下拉式在线阅读平台。日漫、韩漫、国漫海量资源，全站免费无限制，每日同步更新热门连载。
            </p>
          </div>

          {footerLinks.map((group) => (
            <div key={group.title}>
              <h4 className="text-sm font-semibold text-background-50 mb-4">{group.title}</h4>
              <ul className="space-y-2.5">
                {group.links.map((link) => (
                  <li key={link.label}>
                    <a
                      href={link.href}
                      className="text-sm text-background-400 hover:text-primary-400 transition-colors duration-200 whitespace-nowrap cursor-pointer"
                    >
                      {link.label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="border-t border-background-800 pt-6 mb-6">
          <h4 className="text-sm font-semibold text-background-50 mb-3">合作伙伴</h4>
          <p className="text-sm text-background-500">更多合作伙伴即将入驻，敬请期待</p>
        </div>

        <div className="border-t border-background-800 pt-6 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-background-500">
            &copy; 2020 - 2026 哔咔动漫 BIKA COMIC. 日漫韩漫国漫全免费，下拉式在线阅读体验。
          </p>
          <div className="flex items-center gap-4">
            <span className="text-xs text-background-500 cursor-pointer whitespace-nowrap">
              <i className="ri-shield-check-line mr-1"></i>安全阅读
            </span>
            <span className="text-xs text-background-500 cursor-pointer whitespace-nowrap">
              <i className="ri-eye-line mr-1"></i>护眼模式
            </span>
          </div>
        </div>
      </div>
    </footer>
  );
}